import { Component } from '@angular/core';

import {
  AdvancedFilterModel,
  IFilterParams,
  JoinAdvancedFilterModel,
  NumberAdvancedFilterModel,
} from 'ag-grid-enterprise';

import { TextBoxComponent } from '@camelot/form-input';
import { InputNumber, InputPanel } from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';

import { ActiveFilterTag } from '../../../../filters/types';
import { BaseFilterComponent, operatorMap } from '../base-col';
import type { NumberCol } from './number-col';

@Component({
  host: { 'data-cid': 'number-filter' },
  imports: [TextBoxComponent, TextComponent, TranslatePipe],
  styleUrls: ['../filter.scss'],
  template: `
    @if (this.input) {
      <div>
        <div class="filter-title">
          <cam-text [isBold]="true" size="sm" color="brand-primary">{{ this.filterTitle() | translate }}</cam-text>
        </div>
        <div class="p-space-sm">
          @for (input of this.children; track input.key; let first = $first) {
            <div>
              <cam-input-textbox
                [input]="$any(input)"
                [standalone]="true"
                [onFocus]="first ? this.focus$ : undefined"
                (valueChanged)="this.valueChanged()"
              ></cam-input-textbox>
            </div>
          }
        </div>
      </div>
    }
  `,
})
export class NumberFilterComponent extends BaseFilterComponent<
  JoinAdvancedFilterModel | NumberAdvancedFilterModel,
  NumberCol
> {
  get children() {
    const input = this.input;
    if (!(input instanceof InputPanel)) {
      return [];
    }
    return input.children.filter((child): child is InputNumber => child instanceof InputNumber);
  }
  override agInit(params: IFilterParams) {
    super.agInit(params);
  }
  override getTags(model?: AdvancedFilterModel | null): ActiveFilterTag[] {
    if (!model) {
      model = this._model;
    }
    if (!model) {
      return [];
    }
    if (model.filterType === 'number') {
      if (model.filter === undefined) {
        return [];
      }
      const operator = operatorMap[model.type] || model.type;
      return [
        {
          condition: model,
          id: model.colId,
          name: `${operator} ${model.filter}`,
        },
      ];
    }
    if (model.filterType === 'join') {
      return model.conditions.flatMap(condition => this.getTags(condition));
    }

    return [];
  }

  public valueChanged() {
    const data = this.children
      ?.map(child => ({ id: child.key, value: child.value }))
      .reduce<{ [index: string]: number | null }>((acc, child) => {
        acc[child.id] = child.value;
        return acc;
      }, {});

    this.apply(data);
  }
}
